import React from 'react';
import Box from '@bit/knotchinc.web-react-components.box';
import {
  AlertRuleContainer,
  InnerContainer,
  Checkbox,
  RuleTitle,
  RuleDescription,
} from './styled';
import alertTextMap from './alertTextMap';

const AlertRule = ({ data, alertType, changeAlertRule }) => (<AlertRuleContainer>
  <InnerContainer>
    <Checkbox selected={data.rule_enabled} onClick={() => changeAlertRule({ rule_id: data.public_id, rule_enabled: !data.rule_enabled, alertType })} />
    <Box display="inline-block">
      <RuleTitle>{data.name}</RuleTitle>
      <RuleDescription>{alertTextMap[data.name] || 'No description yet.'}</RuleDescription>
    </Box>
  </InnerContainer>
</AlertRuleContainer>);

export default AlertRule;
